/* Keycaps Office — zoom uniforme en cards del catálogo.
   Las fotos de producto sobre fondo claro vienen con distinto encuadre:
   en unas el keycap ocupa el 35% del marco y en otras casi el 100%. Aquí
   medimos el área que difiere del fondo (color tomado de las esquinas de
   cada foto) y ajustamos escala y centrado para que todos los sujetos se
   vean del mismo tamaño, con aire alrededor. Las sombras suaves y el ruido
   se descartan con histogramas por fila/columna.
   Requiere crossorigin="anonymous" (el CDN de Shopify permite CORS); si el
   canvas queda contaminado, no tocamos nada. */
(function () {
  'use strict';

  var TARGET_X = 0.29;  /* fracción del ancho del marco para el sujeto */
  var TARGET_Y = 0.35;  /* tope vertical */
  /* mínimo bajo: las fotos con encuadre apretado (sujeto ~100% de la foto)
     necesitan reducirse a ~0.25x para calzar con el resto; el marco se
     pinta del color de fondo de la foto así que no se nota el borde */
  var MIN_M = 0.2;
  /* subimos el tope de zoom: hay fotos (Reyna, Baby Yoda) con el keycap muy
     pequeño en el encuadre; con 2.1x no alcanzaban el tamaño objetivo y se
     veían más chicas que el resto. Las bien encuadradas no llegan a este tope. */
  var MAX_M = 3.4;
  /* bajo 0.625 la imagen (160% del marco) deja de cubrir el marco: ahí
     pintamos el marco con el color de fondo de la propia foto */
  var COVER_M = 0.635;
  var SAMPLE = 96;      /* resolución del análisis */
  var TOL = 96;         /* distancia RGB al fondo: sombras suaves quedan fuera */
  var ROW_MIN = 2;      /* mínimo de píxeles-sujeto para validar fila/columna */

  var cache = {};
  var canvas, ctx;

  function cornerColor(data, w, h) {
    /* promedio de parches de 3x3 en las 4 esquinas */
    var offs = [[0, 0], [w - 3, 0], [0, h - 3], [w - 3, h - 3]];
    var r = 0, g = 0, b = 0, n = 0;
    for (var c = 0; c < offs.length; c++) {
      for (var y = offs[c][1]; y < offs[c][1] + 3; y++) {
        for (var x = offs[c][0]; x < offs[c][0] + 3; x++) {
          var i = (y * w + x) * 4;
          r += data[i]; g += data[i + 1]; b += data[i + 2]; n++;
        }
      }
    }
    return [r / n, g / n, b / n];
  }

  function diff(data, i, bg) {
    return Math.abs(data[i] - bg[0]) + Math.abs(data[i + 1] - bg[1]) + Math.abs(data[i + 2] - bg[2]);
  }

  function analyze(img) {
    var key = img.currentSrc || img.src;
    if (!key) return null;
    if (key in cache) return cache[key];

    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.width = SAMPLE;
      canvas.height = SAMPLE;
      ctx = canvas.getContext('2d', { willReadFrequently: true });
    }

    var w = SAMPLE, h = SAMPLE, data;
    try {
      ctx.clearRect(0, 0, w, h);
      ctx.drawImage(img, 0, 0, w, h);
      data = ctx.getImageData(0, 0, w, h).data;
    } catch (e) {
      cache[key] = null; /* sin CORS no hay lectura de píxeles */
      return null;
    }

    var bg = cornerColor(data, w, h);

    /* Solo fotos de estudio con fondo claro: si el fondo es oscuro es
       concept art u otro tipo de foto y la dejamos como está. */
    if ((bg[0] + bg[1] + bg[2]) / 3 < 180) {
      cache[key] = null;
      return null;
    }

    /* Fondo uniforme: el borde superior y los tercios altos de los bordes
       laterales deben calzar con el color de esquina (el sujeto puede tocar
       el borde inferior en fotos apretadas, eso es normal). */
    var badEdge = 0, checked = 0, x, y;
    for (x = 0; x < w; x += 2) { if (diff(data, x * 4, bg) > TOL) badEdge++; checked++; }
    for (y = 0; y < Math.floor(h / 3); y += 2) {
      if (diff(data, y * w * 4, bg) > TOL) badEdge++;
      if (diff(data, (y * w + w - 1) * 4, bg) > TOL) badEdge++;
      checked += 2;
    }
    if (badEdge / checked > 0.12) {
      cache[key] = null; /* gradiente o fondo con textura: no tocar */
      return null;
    }

    /* Histogramas: cuántos píxeles-sujeto tiene cada columna y fila.
       Columnas/filas con menos de ROW_MIN se tratan como ruido o sombra. */
    var cols = new Array(w), rows = new Array(h);
    for (x = 0; x < w; x++) cols[x] = 0;
    for (y = 0; y < h; y++) rows[y] = 0;
    for (y = 0; y < h; y++) {
      for (x = 0; x < w; x++) {
        var i = (y * w + x) * 4;
        if (data[i + 3] <= 40 || diff(data, i, bg) <= TOL) continue;
        /* las sombras son gris neutro de luminancia media: se descartan.
           El keycap tiene color (saturación) o líneas oscuras (luz baja). */
        var mx = Math.max(data[i], data[i + 1], data[i + 2]);
        var mn = Math.min(data[i], data[i + 1], data[i + 2]);
        if (mx - mn < 20 && mx > 110) continue;
        cols[x]++; rows[y]++;
      }
    }
    var minX = -1, maxX = -1, minY = -1, maxY = -1;
    for (x = 0; x < w; x++) { if (cols[x] >= ROW_MIN) { if (minX < 0) minX = x; maxX = x; } }
    for (y = 0; y < h; y++) { if (rows[y] >= ROW_MIN) { if (minY < 0) minY = y; maxY = y; } }

    if (maxX < 0 || maxX - minX < 4 || maxY - minY < 4) {
      cache[key] = null; /* sin sujeto claro */
      return null;
    }

    var res = {
      bw: (maxX - minX + 1) / w,
      bh: (maxY - minY + 1) / h,
      cx: (minX + maxX + 1) / 2 / w,
      cy: (minY + maxY + 1) / 2 / h,
      bg: 'rgb(' + Math.round(bg[0]) + ',' + Math.round(bg[1]) + ',' + Math.round(bg[2]) + ')'
    };
    cache[key] = res;
    return res;
  }

  function fit(img) {
    /* con menos de 200px es un placeholder de lazysizes: esperamos la real */
    if (!img.naturalWidth || img.naturalWidth < 200) return;
    var wrapper = img.closest('.grid-view-item__image-wrapper');
    if (!wrapper) return;

    var box = analyze(img);
    if (!box) return;

    var frameW = wrapper.clientWidth;
    var frameH = wrapper.clientHeight;
    if (!frameW || !frameH) return;

    /* La imagen se dibuja con object-fit: cover en una caja del 160% del
       marco (keycap-fx.css); reconstruimos su tamaño real en pantalla. */
    var elW = frameW * 1.6;
    var elH = frameH * 1.6;
    var s = Math.max(elW / img.naturalWidth, elH / img.naturalHeight);

    var subjW = box.bw * img.naturalWidth * s;
    var subjH = box.bh * img.naturalHeight * s;

    var m = Math.min(TARGET_X / (subjW / frameW), TARGET_Y / (subjH / frameH));
    m = Math.max(MIN_M, Math.min(MAX_M, m));

    /* Corrección de centrado, acotada para no revelar el borde de la foto:
       el margen sobrante de la imagen escalada limita el desplazamiento.
       Si el centrado necesita más margen del disponible (o la imagen ya no
       cubre el marco), el marco toma el color de fondo de la foto y así el
       borde deja de importar: el sujeto SIEMPRE queda centrado. */
    var dx = (box.cx - 0.5) * img.naturalWidth * s;
    var dy = (box.cy - 0.5) * img.naturalHeight * s;
    var slackX = Math.max(0, (elW * m - frameW) / 2 - 2);
    var slackY = Math.max(0, (elH * m - frameH) / 2 - 2);
    var wantTx = -m * dx;
    var wantTy = -m * dy;
    if (m < COVER_M || Math.abs(wantTx) > slackX || Math.abs(wantTy) > slackY) {
      wrapper.style.background = box.bg;
      slackX = Math.max(slackX, frameW * 0.3);
      slackY = Math.max(slackY, frameH * 0.3);
    }
    var tx = Math.max(-slackX, Math.min(slackX, wantTx));
    var ty = Math.max(-slackY, Math.min(slackY, wantTy));

    img.style.setProperty('--ko-fit-s', m.toFixed(3));
    img.style.setProperty('--ko-fit-tx', tx.toFixed(1) + 'px');
    img.style.setProperty('--ko-fit-ty', ty.toFixed(1) + 'px');

    ensureRes(img, elW * m);
  }

  /* lazysizes elige la resolución según el ancho del elemento ANTES de que
     apliquemos la escala: si ampliamos 2x, la foto queda corta de píxeles.
     Aquí subimos el tamaño pedido al CDN en proporción al zoom aplicado. */
  var WIDTHS = [360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];
  function ensureRes(img, cssPx) {
    var px = Math.ceil(cssPx);
    if (img.srcset) {
      /* con srcset basta con corregir sizes: el navegador escoge la
         resolución (incluida la densidad de pantalla) por su cuenta */
      var curSizes = parseInt(img.getAttribute('sizes'), 10);
      if (curSizes && curSizes >= px) return;
      img.removeAttribute('data-sizes'); /* frena el "auto" de lazysizes */
      img.setAttribute('sizes', px + 'px');
      return;
    }
    var src = img.currentSrc || img.src;
    var match = src && src.match(/_(\d+)x\./);
    if (!match) return;
    var current = parseInt(match[1], 10);
    var needed = px * Math.min(window.devicePixelRatio || 1, 2);
    if (current >= needed) return;
    var target = WIDTHS[WIDTHS.length - 1];
    for (var i = 0; i < WIDTHS.length; i++) {
      if (WIDTHS[i] >= needed) { target = WIDTHS[i]; break; }
    }
    if (target > current) {
      /* la nueva resolución hereda el análisis: mismas fracciones */
      cache[src.replace(/_(\d+)x\./, '_' + target + 'x.')] = cache[src] || null;
      img.src = src.replace(/_(\d+)x\./, '_' + target + 'x.');
    }
  }

  function eligible(img) {
    return img.classList.contains('grid-view-item__image') &&
      img.closest('.ko-light-collection');
  }

  /* lazysizes avisa cuando cada imagen termina de cargar (incluye las que
     agrega el botón "Ver más") */
  document.addEventListener('lazyloaded', function (e) {
    var img = e.target;
    if (eligible(img)) fit(img);
  });

  function scan() {
    var imgs = document.querySelectorAll('.ko-light-collection .grid-view-item__image');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].complete && imgs[i].naturalWidth) fit(imgs[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var rT;
  window.addEventListener('resize', function () {
    clearTimeout(rT);
    rT = setTimeout(scan, 250);
  }, { passive: true });
})();
